export default __webpack_public_path__ + "static/media/backgroundFormulario.f5da42fe.jpg";